<template>
  <div class="reset-box">
    <div class="reset-box-1">
      <h3> Forget the Passwaord</h3>
      <div class="reset-box-1-bottom">
        <Form
          class="F"
          ref="formInline"
          :model="formInline"
          :rules="ruleInline"
          label-position="top"
          @keyup.enter.native="handleSubmit('formInline')"
        >
          <FormItem prop="email" label="Email address">
            <Input type="text" v-model="formInline.email" placeholder="Email address" />
          </FormItem>
          <FormItem prop="imgCode" label="Captcha">
            <Input v-model="formInline.imgCode" placeholder="Captcha" />
            <img
              class="code"
              :src="code.image"
              alt="Captcha"
              v-if="code && code.image"
              @click="getCode"
            />
          </FormItem>

          <FormItem class="form-code-item" prop="imgCode" label="Text verification code">
            <Input type="text" v-model="formInline.captcha" placeholder="Text verification code：" />
            <Button type="text" v-if="showCode" @click="getCaptcha" class="form-code-btn">Get the verification code</Button>
            <Button type="text" v-else disabled class="form-code-btn" style="right:-6px;color:#ccc;"> Please try again after{{count}} seconds</Button>
          </FormItem>

          <Button
            type="primary"
            @click="handleSubmit('formInline')"
            size="large"
            :loading="loading"
            style="margin-top: 24px;"
          >Next</Button>
        </Form>
      </div>
    </div>
  </div>
</template>

<script>
import { validator } from "@/other/validatorEn";
import { mapActions, mapMutations } from "vuex";

export default {
  name: "reset-password",
  data() {
    return {
      showCode: true, // 是否可以获取验证码
      count: "", // 获取验证码的秒数
      formInline: {
        email: "",
        imgCode: "",
        captcha: ""
      },
      ruleInline: {
        email: validator.email,
        imgCode: [
          { required: true, message: "Please enter the correct captcha on the picture", trigger: "blur" }
        ],
        captcha: [
          {
            required: true,
            message: "请输入正确的验证码",
            trigger: "blur"
          }
        ]
      },
      code: null, // 二维码信息
      remember: true, // 二维码信息
      loading: false
    };
  },
  async created() {
    this.getCode();
  },
  methods: {
    ...mapMutations({
      setUser: "setUser",
      setToken: "setToken",
      setLogin: "setLogin",
      setTokenTime: "setTokenTime"
    }),
    ...mapActions({
      getToken: "loginModule/getToken",
      getMsgCodeEmail: "loginModule/getMsgCodeEmail",
      getUser: "loginModule/getUser",
      getImgCode: "loginModule/getImgCode",
      validateImgCode: "loginModule/validateImgCode",
      validateEmailCode: "loginModule/validateEmailCode"
    }),
    async handleSubmit(name) {
      let form = this.formInline;
      let valid = await this.validForm(name);
      if (!valid) return;
      let codeValid = await this.validMsgCode();
      if (!codeValid) return;
      let formData = {
        grant_type: "password",
        client_id: "cloud.exhibition",
        client_secret: "secret",
        username: form.email,
        password: "000000",
        scope: "synair offline_access",
        login_type: "emailcode"
      };
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 5000);
      let tokenData = await this.getToken(formData);
      if (tokenData) { 
        this.setToken(tokenData.access_token);
        this.setTokenTime(tokenData.expires_in * 1000 + new Date().getTime());
        let user = await this.getUser();
        this.setLogin(true);
        this.$router.push("/loginEn/reset-passwordEn2");
      }
      this.loading = false;
    },
    async getCode() {
      // 获取code
      this.code = await this.getImgCode();
    },
    async downTime() {
      const valid = await this.getMsgCodeEmail(this.formInline.email);
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.showCode = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.showCode = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    async getCaptcha() {
      
      this.$refs.formInline.validateField("imgCode", val => {
        if (val !== "") return;
      });
      this.$refs.formInline.validateField("email", val => {
        if (val !== "") return;
      });
      let codeValid = await this.validCode();
      if (!codeValid) return;
      this.downTime();
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    async validMsgCode() {
      // 验证code
      if (!this.formInline.captcha) return false;
      let valid = this.validateEmailCode({
        Email: this.formInline.email,
        Code: this.formInline.captcha
      });
      if (!valid) {
        this.$Message.error("Verification failed!");
        return false;
      }
      if (valid.errors && valid.errors[0]) {
        this.$Message.error(valid.errors[0].description);
        return false;
      }
      return true;
    },
    async validCode() {
      // 验证code
      if (!this.code || !this.formInline.imgCode) return false;
      let valid = await this.validateImgCode({
        Key: this.code.key,
        Code: this.formInline.imgCode
      });
      if (!valid) { 
        this.$Message.error("Verification failed!");
        return false;
      }
      if (valid.errors && valid.errors[0]) {
        this.$Message.error(valid.errors[0].description);
        this.getCode();
        return false;
      }
      return true;
    },
    linkEx() {
      this.$router.push("/loginEn/bloginEn");
    },
    linkEx2() {
      this.$router.push("/loginEn/aloginEn");
    }
  }
};
</script>

<style lang='scss'>
.reset-box {
  width: 420px;
  min-height: 392px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 70px auto 0;
  &-1 {
    width: 420px;
    min-height: 348px;
    background-color: #fff;
    border-radius: 2px;
    position: relative;
    h3 {
      text-align: center;
      font-size: 20px;
      color: #333;
      font-weight: bold;
      margin-bottom: 40px;
    }
    &-top {
      width: 332px;
      height: 40px;
      margin: 40px auto 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .p1 {
        width: 91px;
        height: 17px;
        font-size: 18px;
        line-height: 16px;
        color: #808080;
        cursor: pointer;
        font-weight: bold;
      }
      .p2 {
        height: 19px;
        font-size: 18px;
        line-height: 16px;
        cursor: pointer;
        color: #666;
        &.active,
        &:hover {
          color: #d13119;
        }
      }
      .p3 {
        color: #808080;
        &:hover {
          color: #d13119;
        }
      }
    }
    &-bottom {
      width: 360px;
      min-height: 350px;
      margin: 0 auto;
    }
  }
  .wx-icon {
    width: 22px;
    height: 22px;
    padding: 3px 5px;
    background-color: #3eb135;
    border-radius: 50%;
    display: inline-block;
    margin-right: 8px;
    img {
      width: 13px;
      height: 11px;
    }
  }
}
.F {
  display: flex;
  flex-direction: column;
  width: 360px;
  height: 350px;
  position: relative;
  .ivu-input {
    height: 42px;
  }
  &-1 {
    margin-top: 15px;
    margin-bottom: 0;
    .I {
      margin-top: 19px;
    }
  }
  .F-2 {
    width: 100%;
    height: 15px;
    line-height: 15px;
    display: flex;
    justify-content: flex-end;
    margin: 24px 0;
    .F-2-text {
      width: 60px;
      height: 13px;
      cursor: pointer;
      font-size: 14px;
      color: #666;
    }
  }
  .code {
    width: 70px;
    height: 26px;
    position: absolute;
    top: 8px;
    right: 8px;
    cursor: pointer;
  }
}
.form-code-item {
  position: relative;
  .form-code-btn {
    position: absolute;
    right: -6px;
    top: 6px;
    border: none;
    outline: none;
    color: #1890f1;
    background: transparent;
    &:focus {
      box-shadow: none;
      border: none;
      outline: none;
    }
  }
}
.login-re {
  text-align: center;
  margin-top: 20px;
  span {
    text-decoration: underline;
    font-size: 14px;
    color: #666;
    cursor: pointer;
  }
}
</style>